import { motion } from "framer-motion";

export const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -10 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const CTAButton = ({ label, testId, variant = "solid", className = "" }) => {
  const base =
    "group relative inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-colors duration-300 rounded-[3px]";
  const styles =
    variant === "solid"
      ? "bg-terra text-cream hover:bg-terra-dark"
      : variant === "invert"
      ? "bg-cream text-green hover:opacity-90"
      : "border border-[var(--hairline)] text-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--page)]";
  return (
    <motion.button
      data-testid={testId}
      onClick={scrollToForm}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
      className={`${base} ${styles} ${className}`}
    >
      <span>{label}</span>
      <span className="cta-arrow inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
    </motion.button>
  );
};
